import PropTypes from 'prop-types'
import React from 'react'
import Column from '../../layouts/Column'
import Flex from '../../layouts/Flex'
import Row from '../../layouts/Row'
import Spacer from '../../layouts/Spacer'
import Button from '../Button'
import CaseTeaser from '../CaseTeaser'
import '../../global/global.scss'

const CaseTeaserGallery = ({ caseStudies }) => (
  <>
    <Row width="large">
      {caseStudies.map((study, index) => {
        return (
          <Column key={index} span={12} spanWhen={{ md: 6 }}>
            <CaseTeaser
              index={index}
              client={study.client}
              to={'/cases/' + study.slug}
              description={study.excerpt}
              backgroundColor={study.backgroundColor}
              desktopImage={
                study.desktopImage && (
                  <img
                    src={study.desktopImage.src}
                    srcSet={study.desktopImage.srcSet}
                    alt={study.desktopImage.alt}
                    className="fit-image"
                  />
                )
              }
              mobileImage={
                study.mobileImage && (
                  <img
                    src={study.mobileImage.src}
                    srcSet={study.mobileImage.srcSet}
                    alt={study.mobileImage.alt}
                    className="fit-image"
                  />
                )
              }
              layout={index + 1}
            />
          </Column>
        )
      })}
    </Row>
    <Spacer size="xl" when={{ lg: 'xxl' }} />
    <Flex justify="center">
      <Button label="Alle Cases entdecken" to="/cases" ghost />
    </Flex>
    <Spacer size="s" when={{ lg: 's' }} />
  </>
)

CaseTeaserGallery.propTypes = {
  caseStudies: PropTypes.array
}

export default CaseTeaserGallery
